import React from "react";
import "./yuflyma-banner.css";

const YuflymaBanner = () => {
  return (
  
      
        <section className="yuf-banner" aria-label="Important program update">
          <div className="yuf-topbar">
            <div className="yuf-topbar__inner">
              <span className="yuf-topbar__text">IMPORTANT PROGRAM UPDATE</span>
            </div>
          </div>

          <div className="yuf-inner">
            <h1 className="yuf-headline">
              Yuflyma (adalimumab-aaty) injection has been discontinued in the
              US market.
            </h1>
           
              <div className="yuf-grid">
                <div className="yuf-col">
                  <p className="yuf-p">
                    The decision to discontinue Yuflyma (adalimumab-aaty) is not
                    related to any safety, efficacy, or quality concerns.
                    Patients should speak with their healthcare provider about
                    alternative treatments.
                  </p>

                  <p className="yuf-p yuf-mt-lg">
                    Please note that unbranded adalimumab-aaty will continue to
                    be available after Yuflyma is discontinued. Patients must
                    re-apply for assistance for adalimumab-aaty.
                  </p>

                  <p className="yuf-p yuf-mt-lg">
                    Visit{" "}
                    <a
                      className="yuf-link"
                      href="https://www.celltrionconnect.com"
                      target="_blank"
                      rel="noreferrer"
                    >
                      www.CelltrionCONNECT.com.
                    </a>
                  </p>
                </div>

                <div className="yuf-col">
                  <p className="yuf-p">
                    If you have questions, please contact the Celltrion CONNECT
                    Patient Support Program at{" "}
                    <strong>1-877-81CONNC (1-877-812-6662)</strong>, which will
                    be available until <strong>March 31, 2026</strong>.
                  </p>

                  <div
                    className="yuf-callout"
                    aria-label="Claims deadline callout"
                  >
                    <p className="yuf-callout__text">
                      <strong>March 31, 2026</strong> is the last day to process
                      claims through the Celltrion CARES Co-pay Assistance
                      Program.
                    </p>
                  </div>

                  <div className="yuf-footer">
                    US-YUF-25-00035v2&nbsp;&nbsp;2/26
                  </div>
                </div>
              </div>
            
          </div>
        </section>
      
  
  );
};

export default YuflymaBanner;
